import styled, { css } from 'styled-components';

import { Button as DefaultButton } from '@xing-com/button';
import { Card as DefaultCard } from '@xing-com/card';
import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import { spaceM } from '@xing-com/tokens';
import { BodyCopy as DefaultBodyCopy } from '@xing-com/typography';

const CardContent = css`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};
  justify-content: space-between;

  @media ${mediaWideNavless} {
    flex-direction: row;
    align-items: center;
  }
`;

export const Card = styled(DefaultCard)`
  display: none;
  @media ${mediaConfined} {
    display: flex;
  }

  & > * {
    ${CardContent}
  }
`;

export const BodyCopy = styled(DefaultBodyCopy)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const Button = styled(DefaultButton)`
  width: 258px;
`;

export const SmallDevice = styled.div`
  @media ${mediaConfined} {
    display: none;
  }
`;
